export const SET_USER_INFO = "set_user_info";
export const SET_PROJECTS = "set_projects";
export const UPDATE_PROJECTS_LIST = "update_projects_list";
export const SET_USERS = "set_users";
export const UPDATE_USERS_LIST = "update_users_list";
export const SET_COUNTER_TYPES = "set_counter_types";
export const UPDATE_COUNTER_TYPES = "update_counter_types";
export const SET_COUNTERS = "set_counters";
export const UPDATE_COUNTERS_LIST = "update_counters_list";
export const SET_STATISTICS = "set_statistics";
export const SET_PROJECTS_BY_CITIES = "set_projects_by_cities";
export const SET_TYPES_INFO = "set_types_info";
export const SET_ADMIN_PROFILE = "set_admin_profile";
export const SET_COUNTER_CATEGORIES = "set_counter_categories";
export const UPDATE_PROFILE = "update_profile";

export const UPDATE_SHOW_USERS_LIST_MODE = "update_show_users_list_mode";
export const UPDATE_SHOW_PROJECTS_LIST_MODE = "update_show_projects_list_mode";
export const UPDATE_SHOW_COUNTER_TYPE_LIST_MODE =
  "update_show_counter_type_list_mode";
export const UPDATE_SHOW_COUNTER_LIST_MODE = "update_show_counter_list_mode";
export const UPDATE_SHOW_PROJECT_WATER_COUNTERS_LIST_MODE =
  "update_show_project_water_counters_list_mode";
export const UPDATE_SHOW_PROJECT_POWER_COUNTERS_LIST_MODE =
  "update_show_project_power_counters_list_mode";
export const UPDATE_SHOW_PROJECT_GAS_COUNTERS_LIST_MODE =
  "update_show_project_gas_counters_list_mode";

export const UPDATE_ACCESS_TABLE = "update_access_table";
export const UPDATE_ADMINS_TABLE = "update_admins_table";
export const UPDATE_BILLS_TABLE = "update_bills_table";

export const UPDATE_PROJECT_COUNTER_TYPES = "update_project_counter_types";

export const UPDATE_PROJECT = "update_project";

export const UPDATE_NAVIGATIONS = "update_navigations";
